import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";
import { HoldAndSpinSchema, AGSPickSchema, AGSSpinSchema } from "ags/integration/schema/ags-spin-response-schema";
import Gameplay from "slotworks/model/gameplay/gameplay";
import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request-payload";
import { HoldAndSpinRecordBuilder } from "ags/integration/builders/records/hold-and-spin-record-builder";
import mcPickRecordGridGenerator from "utils/mc-pick-record-grid-generator";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import gameState from "slotworks/model/game-state";

class LLHoldAndSpinRecordBuilder extends HoldAndSpinRecordBuilder {

    public id: string = "HoldAndSpinRecordBuilder";

    public filter(request: any, response: any): boolean {
        return request instanceof PickRequestPayload;
    }

    public build(gameplay: Gameplay, request: any, response: any): HoldAndSpinRecord[] {
        super.build(gameplay, request, response);

        const parsedResponse = this.getRootAGSRecord(response);
        const spinData = parsedResponse.publicState.spin;
        const childFeature = spinData.childFeature;
        const feature = childFeature[childFeature.length - 1] as HoldAndSpinSchema;

        return [this.buildHoldAndSpinRecord(feature, gameplay, childFeature as HoldAndSpinSchema[], spinData)];
    }

    public buildHoldAndSpinRecord(feature: HoldAndSpinSchema, gameplay: Gameplay, childFeature?: HoldAndSpinSchema[], spinData?: AGSSpinSchema): HoldAndSpinRecord {
        const record = super.buildRecord(feature, gameplay, spinData);

        record.issuesRetrigger = this.issuesRetrigger(feature, childFeature);

        return record;
    }

    protected issuesRetrigger(feature: HoldAndSpinSchema, childFeature: HoldAndSpinSchema[]) {
        const rootRecord = gameState.getCurrentGame().getRootRecord();
        const pickResults = mcPickRecordGridGenerator.getMostRecentChildFeatures(rootRecord as SpinRecord, childFeature);
        const isThirdPick = pickResults.length >= 3 && this.getBonusSpinsPlayed(feature) === 1;
        const allPicksAreEmpty = pickResults.every((pickResult) => !this.hasBonusSymbols(pickResult));
        const isNotLastSpin = !feature.complete;

        return isThirdPick && allPicksAreEmpty && isNotLastSpin;
    }

    protected getBonusSpinsPlayed(feature: HoldAndSpinSchema): number {
        return feature.freeSpinsspun + 1;
    }

    protected hasBonusSymbols(feature: HoldAndSpinSchema) {
        return feature.MCSymbols.some((symbol) => symbol.winAmount > 0);
    }
}

export default new LLHoldAndSpinRecordBuilder();
